export const FETCH_PAYMENTS = 'DETALIZATION_NEW:FETCH_PAYMENTS';
export const FETCH_PAYMENTS_SUCCESS = 'DETALIZATION_NEW:FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_ERROR = 'DETALIZATION_NEW:FETCH_PAYMENTS_ERROR';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
